<template>
  <div id="dialogRelatorios">
    <v-layout justify-center>
      <v-dialog
        v-model="cardRelatorio.ativo"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="#042333">
            <v-btn icon dark @click="fecharDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-toolbar-title>{{ cardRelatorio.titulo }}</v-toolbar-title>
          </v-toolbar>

          <v-layout class="px-1">
            <v-data-table
              :headers="cardRelatorio.headers"
              :items="dessets"
              :fixed-header="true"
              :search="search"
              item-key="itemKeyDataTable"
              class="table-full-screen font-resp-tabela"
              style="width: 100%"
              :show-expand="cardRelatorio.metodo == 9 ? true : false"
              :single-expand="true"
              :expanded.sync="itemExpandido"
              :no-data-text="noDataText"
              :item-class="rowColor"
              :items-per-page="50"
              height="calc(100vh - 180px)"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <h4 class="ml-n3">{{ cardRelatorio.info }}</h4>

                  <v-divider class="mx-4" inset vertical></v-divider>

                  <v-spacer></v-spacer>

                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisa"
                    class="ml-5 mr-5 mt-1"
                    single-line
                    hide-details
                    clearable
                    outlined
                    dense
                    v-lazy-input:debounce="500"
                    style="max-width: 550px"
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    title="Exportar Para Excel"
                    @click="exportarRelatorio()"
                  >
                    <v-icon>mdi-file-export</v-icon>Exportar
                  </v-btn>
                </v-toolbar>
              </template>
              <template slot="body.prepend">
                <tr class="totalizadores">
                  <th v-if="totalizador[header.value]" v-for="header in cardRelatorio.headers">
                    {{ (typeof totalizador[header.value]) !== 'string' ? Helpers.formatarValor(totalizador[header.value]) : totalizador[header.value] }}
                  </th>
                </tr>
                <tr style="border: 1px solid red" v-if="loading">
                  <td :colspan="cardRelatorio.headers.length" id="tr-progress">
                    <v-progress-linear
                      indeterminate
                      rounded
                      color="red"
                    ></v-progress-linear>
                  </td>
                </tr>
              </template>
              <template v-slot:item.filial_perda_venda="{ item }">
                <div style="display: flex">
                  {{ item.filial }}
                  <div
                    v-if="
                      item.tipo_status === 'INATIVO' ||
                      item.tipo_status === 'FL'
                    "
                    style="margin-top: -10px"
                    class="ml-1"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" color="red">
                          <v-icon>mdi-alert-octagon</v-icon>
                        </v-btn>
                      </template>
                      <span v-if="item.tipo_status === 'INATIVO'">
                        PRODUTO INATIVO
                      </span>
                      <span v-else>PRODUTO FORA DE LINHA</span>
                    </v-tooltip>
                  </div>
                </div>
              </template>
              <template v-slot:item.estoque="{ item }">
                <template v-if="Number(item.estoque) < 1">
                  {{Helpers.formatarValorComCasas(item.estoque, 4)}}
                </template>
                <template v-else>
                  {{ Helpers.formatarValor(item.estoque) }}
                </template>
              </template>
              <template v-slot:item.estoque_grupo_dia_ult_saida="{ item }">
                {{ Helpers.formatarValor(item.estoque_grupo_dia_ult_saida) }}
              </template>
              <template v-slot:item.estoque_seguranca="{ item }">{{
                Helpers.formatarValor(item.estoque_seguranca)
              }}</template>
              <template v-slot:item.ponto_pedido="{ item }">{{
                Helpers.formatarValor(item.ponto_pedido)
              }}</template>
              <template v-slot:item.estoque_maximo="{ item }">{{
                Helpers.formatarValor(item.estoque_maximo)
              }}</template>
              <template v-slot:item.cobertura_estoque="{ item }">{{
                Helpers.formatarValor(item.cobertura_estoque)
              }}</template>
              <template v-slot:item.consumo_medio_mensal="{ item }">{{
                Helpers.formatarValor(item.consumo_medio_mensal)
              }}</template>
              <template v-slot:item.estoque_excesso="{ item }">{{
                Helpers.formatarValor(item.estoque_excesso)
              }}</template>
              <template v-slot:item.compra_transito="{ item }">{{
                Helpers.formatarValor(item.compra_transito)
              }}</template>
              <template v-slot:item.venda_diaria_calc="{ item }">{{
                Helpers.formatarValorMonetario(item.venda_diaria_calc)
              }}</template>
              <template v-slot:item.total_ruptura="{ item }">{{
                Helpers.formatarValorMonetario(item.total_ruptura)
              }}</template>
              <template v-slot:item.preco_medio_venda="{ item }">{{
                Helpers.formatarValorMonetario(item.preco_medio_venda)
              }}</template>
              <template v-slot:item.media_mensal="{ item }">{{
                Helpers.formatarValor(item.media_mensal)
              }}</template>
              <template v-slot:item.custo_unitario="{ item }">{{
                Helpers.formatarValorMonetario(item.custo_unitario)
              }}</template>
              <template v-slot:item.total="{ item }">{{
                Helpers.formatarValorMonetario(item.total)
              }}</template>
              <template v-slot:item.consumo_medio="{ item }">{{
                Helpers.formatarValor(item.consumo_medio)
              }}</template>
              <template v-slot:item.estoque_transito="{ item }">{{
                Helpers.formatarValor(item.estoque_transito)
              }}</template>
              <template v-slot:item.lista_pedidos_em_aberto="{ item }">
                <slot name="item.lista_pedidos_em_aberto" :item="item" />
              </template>
              <template v-slot:item.excesso="{ item }">{{
                Helpers.formatarValor(item.excesso)
              }}</template>
              <template v-slot:item.total_estoque_excesso="{ item }">{{
                Helpers.formatarValorMonetario  (item.total_estoque_excesso)
              }}</template>

              <template v-slot:item.dialog_detalhes_produtos="{item}">
                <dialog-detalhes-produto
                  :produto="{
                    id_grupo: cardRelatorio.filtros.grupo,
                    id_filial: (cardRelatorio.filtros.filial === 'Todas') ? 9999 : cardRelatorio.filtros.filial,
                    id_produto: item.idproduto
                  }"
                ></dialog-detalhes-produto>
              </template>

              <template v-slot:item.qtde_vencidos="{ item }">
                <span
                  style="cursor: pointer"
                  @click="
                    dialogValidadeLotes = true;
                    produto.idproduto = item.idproduto;
                  "
                >
                  {{ Helpers.formatarValor(item.qtde_vencidos) }}
                </span>
              </template>
              <template v-slot:item.qtde_dias_ruptura="{ item }">
                <span
                  @click="
                    dialogDetalhamentoRuptura = true;
                    buscarDadosdialogDetalhamentoRuptura(item);
                  "
                  style="cursor: pointer"
                  >{{ Helpers.formatarValor(item.qtde_dias_ruptura) }}</span
                >
              </template>
              <template v-slot:item.qtde_dias_diferenca="{ item }">
                <span
                  :style="
                    item.qtde_dias_diferenca >= 0
                      ? 'color: green'
                      : 'color: red'
                  "
                  :title="
                    item.qtde_dias_diferenca >= 0
                      ? 'A última solicitação de compra foi feita antes da ruptura.'
                      : 'A última solicitação de compra foi feita após a ruptura.'
                  "
                >
                  {{ Math.abs(item.qtde_dias_diferenca) }}
                </span>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <h3 style="padding: 15px; padding-top: 25px">
                    Produto {{ item.idproduto }} por Filial
                  </h3>
                  <table style="width: 100%">
                    <tr style="color: #555">
                      <th>Filial</th>
                      <th>Estoque</th>
                      <th>Estoque Segurança</th>
                      <th>Ponto de Pedido</th>
                      <th>Estoque Máximo</th>
                      <th>Última Saída</th>
                      <th>Total</th>
                    </tr>
                    <tr v-for="item in produtoPorFilial" :key="item.filial">
                      <td>{{ item.filial }}</td>
                      <td>{{ Helpers.formatarValor(item.estoque) }}</td>
                      <td>
                        {{ Helpers.formatarValor(item.estoque_seguranca) }}
                      </td>
                      <td>{{ Helpers.formatarValor(item.ponto_pedido) }}</td>
                      <td>{{ Helpers.formatarValor(item.estoque_maximo) }}</td>
                      <td>{{ item.ult_saida }}</td>
                      <td>{{ Helpers.formatarValor(item.total) }}</td>
                    </tr>
                  </table>
                </td>
              </template>
              <template v-slot:item.estoque_solicitacao="{ item }">
                {{ Helpers.formatarValor(item.estoque_solicitacao) }}
              </template>
              <template v-slot:item.qtde_pedido="{ item }">
                {{ Helpers.formatarValor(item.qtde_pedido) }}
              </template>
            </v-data-table>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- DIALOG DE DETALHAMENTO DE RUPTURAS -->
    <v-layout justify-center>
      <v-dialog
        v-model="dialogDetalhamentoRuptura"
        persistent
        max-width="1100px"
      >
        <v-card>
          <v-card-title class="pb-0">
            <v-btn
              icon
              @click="dialogDetalhamentoRuptura = false"
              style="margin-left: -10px; margin-right: 10px"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span class="headline">Detalhamento das Ruptura</span>
          </v-card-title>
          <v-card-text>
            <v-container class="pb-0">
              <v-layout class="pa-0 ma-0 mb-3">
                <v-flex xs12 class="ma-1">
                  <h4>Produto: {{ infoDetalhamentoRuptura.produto }}</h4>
                  <h4>Fornecedor: {{ infoDetalhamentoRuptura.fornecedor }}</h4>
                  <h4>Período: {{ infoDetalhamentoRuptura.data }}</h4>
                </v-flex>
              </v-layout>
              <span style="font-weight: bolder; font-size: 1.07rem; color: #555"
                >Última Compra</span
              >
              <v-layout class="pa-0 ma-0 mb-1" v-if="ultimaCompra.ordem_compra">
                <v-flex xs5>
                  <p class="texto-valor">
                    <span>Ordem Compra:</span> {{ ultimaCompra.ordem_compra }}
                  </p>
                  <p class="texto-valor">
                    <span>Data Solicitação:</span>
                    {{ ultimaCompra.data_solicitacao }}
                  </p>
                  <p class="texto-valor">
                    <span>Comprador:</span> {{ ultimaCompra.nome_comprador }}
                  </p>
                </v-flex>
                <v-flex xs5>
                  <p class="texto-valor">
                    <span>Estoque Solicitação:</span>
                    {{
                      Helpers.formatarValor(ultimaCompra.estoque_solicitacao)
                    }}
                  </p>
                  <p class="texto-valor">
                    <span>Status Percepção:</span>
                    {{ ultimaCompra.status_percepcao }}
                  </p>
                </v-flex>
                <v-flex xs2>
                  <p class="texto-valor">
                    <span>Qtde. Pedido:</span>
                    {{ Helpers.formatarValor(ultimaCompra.qtde_pedido) }}
                  </p>
                  <p class="texto-valor">
                    <span>Qtde. Entregue:</span>
                    {{ Helpers.formatarValor(ultimaCompra.qtde_entregue) }}
                  </p>
                  <p class="texto-valor">
                    <span>Qtde. Pendente:</span>
                    {{ Helpers.formatarValor(ultimaCompra.qtde_pendente) }}
                  </p>
                </v-flex>
              </v-layout>
              <v-data-table
                :headers="headersDetalhamentoRuptura"
                :items="itemsDetalhamentoRuptura"
                :fixed-header="true"
                :items-per-page="-1"
                :height="230"
                class="elevation-3"
              >
                <template v-slot:item="props">
                  <tr>
                    <td>{{ props.item.filial }}</td>
                    <td>{{ props.item.data }}</td>
                    <td>{{ Helpers.formatarValor(props.item.estoque) }}</td>
                    <td>
                      {{ Helpers.formatarValor(props.item.media_diaria) }}
                    </td>
                    <td>{{ Helpers.formatarValor(props.item.saldo_grupo) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout>
      <v-dialog v-model="dialogValidadeLotes" persistent width="90%">
        <v-card>
          <v-card-title>
            <v-btn
              color="#000"
              icon
              style="margin-left: -10px"
              @click="dialogValidadeLotes = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span class="headline ml-3">Validade de Lotes</span>
          </v-card-title>
          <v-card-text class="mt-3">
            <chart-validade-lotes
              v-if="dialogValidadeLotes"
              :idproduto="produto.idproduto"
            ></chart-validade-lotes>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import RelatorioAPI from "./../../api/relatorio";
import { mapGetters } from "vuex";
import ChartValidadeLotes from "../compra/ChartValidadeLotes";
import $axios from '../../api/api.js'
import dialogDetalhesProduto from "../produto/detalhes/Index.vue"

export default {
  components: { ChartValidadeLotes, dialogDetalhesProduto },
  props: ["cardRelatorio"],

  data() {
    return {
      search: "",
      dialogDetalhamentoRuptura: false,
      dialogValidadeLotes: false,
      loading: false,
      infoDetalhamentoRuptura: {},
      ultimaCompra: {},
      itemExpandido: [],
      produtoPorFilial: [],
      produto: {
        idproduto: "",
      },

      headersDetalhamentoRuptura: [
        { text: "Filial", value: "filial" },
        { text: "Data", value: "data" },
        { text: "Estoque", value: "estoque" },
        { text: "Média Diária", value: "media_diaria" },
        { text: "Estoque Grupo", value: "saldo_grupo" },
      ],
      itemsDetalhamentoRuptura: [],
    };
  },

  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
    noDataText() {
      return this.loading ? "Carregando itens..." : "Não há dados disponíveis.";
    },
    dessets() {
      if (this.loading || !this.cardRelatorio.itens || this.cardRelatorio.itens.length === 0) {
        return [];
      }

      return this.cardRelatorio.itens.map((item, index) => {
        item.itemKeyDataTable = index;
        return item;
      });
    },
    totalizador() {
      const totais = {
        idfamilia_produto: '#',
        descricao_familia_produto: 'TOTALIZADORES',
        idproduto: '-',
        cod_produto: '-',
        tipo_compra: '-',
        descricao_produto: '-',
        codigo_barras: '-',
        unidade_compra: '-',
        estoque: 0,
        estoque_seguranca: 0,
        ponto_pedido: 0,
        estoque_maximo: 0,
        cobertura_estoque: 0,
        consumo_medio_mensal: 0,
        estoque_excesso: 0,
        compra_transito: 0,
        status_compra: '-',
        sugestao: 0,
      }

      this.dessets.forEach(produto => {
        totais.estoque += parseFloat(produto.estoque ? produto.estoque : 0);
        totais.estoque_excesso += parseFloat(produto.estoque_excesso ? produto.estoque_excesso : 0);
        totais.estoque_maximo += parseFloat(produto.estoque_maximo ? produto.estoque_maximo : 0);
        totais.estoque_seguranca += parseFloat(produto.estoque_seguranca ? produto.estoque_seguranca : 0);
        totais.ponto_pedido += parseFloat(produto.ponto_pedido ? produto.ponto_pedido : 0);
        totais.cobertura_estoque += parseFloat(produto.cobertura_estoque ? produto.cobertura_estoque : 0);
        totais.compra_transito += parseFloat(produto.compra_transito ? produto.compra_transito : 0);
        totais.consumo_medio_mensal += parseFloat(produto.consumo_medio_mensal ? produto.consumo_medio_mensal : 0);
        totais.sugestao += parseFloat(produto.sugestao ? produto.sugestao : 0);
      });

      return totais;
    }
  },

  watch: {
    cardRelatorio() {
      switch (this.cardRelatorio.metodo) {
        case 1:
          this.buscarProdutosTotal();
          break;
        case 2:
          this.buscarProdutosExcesso();
          break;
        case 3:
          this.buscarProdutosOk();
          break;
        case 4:
          this.buscarProdutosAComprar();
          break;
        case 5:
          this.buscarProdutosEmTransito();
          break;
        case 6:
          this.buscarProdutoPerdaVendaRuptura();
          break;
        case 7:
          this.buscarStatusProduto();
          break;
        case 8:
          this.buscarProdutosStatusMensal();
          break;
        case 9:
          this.buscarProdutosNivelImportancia();
          break;
        case 10:
          this.buscarProdutosStatusPercepcao();
          break;

        default:
          this.cardRelatorio.ativo = false;
      }
    },

    itemExpandido() {
      if (this.itemExpandido[0]) {
        this.buscarProdutoPorFilial();
      }
    },
  },
  methods: {
    rowColor(item) {
      if (!item.tipo_status) return "";

      if (item.tipo_status === "INATIVO" || item.tipo_status === "FL") {
        return "text-color-red";
      } else {
        return "";
      }
    },
    buscarProdutosStatusPercepcao() {
      this.loading = true;
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupos: [this.grupoCompra],
        filial: this.cardRelatorio.filtros.filial,
        compradores: this.cardRelatorio.filtros.comprador === -1 ? [] : [this.cardRelatorio.filtros.comprador],
        fornecedor: this.cardRelatorio.filtros.fornecedor,
        status_percepcao: this.cardRelatorio.filtros.status_percepcao,
        ano_mes: this.cardRelatorio.filtros.ano_mes,
      };

      this.cardRelatorio.itens = [];

      RelatorioAPI.getProdutosPercepcaoCompra(headers, params)
        .then((response) => {
          const { token, produtos } = response.data;
          localStorage.setItem("token", token);
          this.cardRelatorio.itens = produtos;
          this.loading = false;
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    buscarProdutoPorFilial() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        status: this.cardRelatorio.filtros.status,
        idproduto: this.itemExpandido[0].idproduto,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getProdutoPorFilial(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.produtoPorFilial = response.data.produtos;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    produtoSelecionado(item) {
      this.infoDetalhamentoRuptura = {
        produto: item.idproduto + " - " + item.descricao_produto,
        fornecedor: item.idfornecedor + " - " + item.razao_social,
        data: (item.mes < 10 ? "0" + item.mes : item.mes) + "/" + item.ano,
      };
    },

    buscarDadosdialogDetalhamentoRuptura(item) {
      this.produtoSelecionado(item);

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        idproduto: item.idproduto,
        filial: item.filial,
        ano: item.ano,
        mes: item.mes,
        pedido_compra: item.pedido_compra,
      };

      this.itemsDetalhamentoRuptura = [];

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getDetalhamentoRuptura(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.itemsDetalhamentoRuptura = response.data.diasRuptura;

            if (response.data.ultimaCompra[0]) {
              this.ultimaCompra = response.data.ultimaCompra[0];
            } else {
              this.ultimaCompra = {};
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarProdutosNivelImportancia() {
      const headers = this.Helpers.iniciarRequisicao();

      const { compradores, filial_financeiro, nivel_servico } =
        this.cardRelatorio.filtros;

      const params = {
        grupo: this.grupoCompra,
        filial: this.cardRelatorio.filtros.filial,
        fornecedor: this.cardRelatorio.filtros.fornecedor,
        status: this.cardRelatorio.filtros.status,
        tipoRelatorio: this.cardRelatorio.filtros.tipoRelatorio,
        grupo_venda: this.cardRelatorio.filtros.grupo_venda,
        nivel_servico: filial_financeiro == "" ? nivel_servico : "",
        filial_financeiro: nivel_servico == "" ? filial_financeiro : 0,
        compradores: compradores,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getProdutosNivelImportancia(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.cardRelatorio.info = "";
            this.cardRelatorio.itens = [];

            this.cardRelatorio.ativo = true;
            this.cardRelatorio.info = response.data.info;
            this.cardRelatorio.itens = response.data.produtos;

            if (
              !response.data.lote_produtos &&
              this.cardRelatorio.headers[7].value == "qtde_vencidos"
            ) {
              this.cardRelatorio.headers.splice(7, 1);
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarProdutosStatusMensal() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        filial: this.cardRelatorio.filtros.filial,
        ano: this.cardRelatorio.filtros.ano,
        mes: this.cardRelatorio.filtros.mes,
        paraDialog: true,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getProdutosStatusMensal(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.cardRelatorio.info = "";
            this.cardRelatorio.itens = [];

            this.cardRelatorio.ativo = true;
            this.cardRelatorio.info = response.data.info;
            this.cardRelatorio.itens = response.data.produtos;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarStatusProduto() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        filial: this.cardRelatorio.filtros.filial,
        departamento: this.cardRelatorio.filtros.departamento,
        fornecedor: this.cardRelatorio.filtros.fornecedor,
        comprador: this.cardRelatorio.filtros.comprador,
        mes: this.cardRelatorio.filtros.mes,
        ano: this.cardRelatorio.filtros.ano,
        status_produto: this.cardRelatorio.filtros.status_produto,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getStatusProduto(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.cardRelatorio.info = "";
            this.cardRelatorio.itens = [];

            this.cardRelatorio.ativo = true;
            this.cardRelatorio.info = response.data.info;

            const produtos = response.data.produtos;

            produtos.forEach((produto) => {
              produto.razao_social =
                produto.id_fornecedor + " - " + produto.razao_social;

              produto.descricao_produto =
                produto.idproduto + " - " + produto.descricao_produto;

              let estoque_excesso =
                parseFloat(produto.estoque) -
                parseFloat(produto.estoque_maximo);

              if (estoque_excesso > 0) {
                produto.excesso = estoque_excesso;
              } else {
                produto.excesso = 0;
              }

              produto.total_estoque_excesso =
                parseFloat(produto.excesso) *
                parseFloat(produto.custo_unitario);
            });

            this.cardRelatorio.itens = produtos;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    exportarRelatorio() {
      let url = "";

      if (this.cardRelatorio.url) {
        url = this.cardRelatorio.url;
        url += "?grupo=" + this.grupoCompra;

        for (let chave in this.cardRelatorio.filtros) {
          if (
            this.cardRelatorio.filtros[chave] != "" &&
            this.cardRelatorio.filtros[chave] != 0
          ) {
            if (chave == "compradores") {
              url += "&" + chave + "[]=" + this.cardRelatorio.filtros[chave];
            } else {
              url += "&" + chave + "=" + this.cardRelatorio.filtros[chave];
            }
          }
        }

        url += "&tipoR=" + "EXCEL";
        url += "&usuario=" + localStorage.getItem("nome");
        url += `&id_usuario=${localStorage.id}`;
      } else {
        /*
         **  cardRelatorio.metodo: varia de 1 a 5 e determina o relatorio clicado pelo usuario
         **  relatorios do grid principal, quando for incluir aqui, mudar filtros para esse padrao: filtros: { *campos* }
         */

        url = "relatorio_dashboard_grid";

        url += "?relatorioEscolhido=" + this.cardRelatorio.metodo;
        url += "&grupo=" + this.grupoCompra;
        url += "&grupo_de_analise=" + this.cardRelatorio.grupo_de_analise;

        if (parseInt(this.cardRelatorio.familia_produto) >= 0) {
          url += "&familia_produto=" + this.cardRelatorio.familia_produto;
        } else if (parseInt(this.cardRelatorio.comprador) >= 0) {
          url += "&comprador=" + this.cardRelatorio.comprador;
        } else {
          url += "&fornecedor=" + this.cardRelatorio.fornecedor;
        }
      }

      url += `&id_usuario=${localStorage.id}`;

      window.open($axios.defaults.baseURL + "/" + url, "_blank");
    },

    fecharDialog() {
      this.$emit("defaultCard", {
        titulo: "",
        headers: [],
        itens: [],
        familia_produto: 0,
        comprador: 0,
        fornecedor: 0,
        info: "",
        ativo: false,
      });
    },

    buscarProdutoPerdaVendaRuptura() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        filial: this.cardRelatorio.filtros.filial,
        segmento: this.cardRelatorio.filtros.segmento,
        fornecedor: this.cardRelatorio.filtros.fornecedor,
        comprador: this.cardRelatorio.filtros.comprador,
        nivel_servico: this.cardRelatorio.filtros.nivel_servico,
        mes: this.cardRelatorio.filtros.mes,
        ano: this.cardRelatorio.filtros.ano,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getProdutosPerdaVendaRuptura(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.cardRelatorio.ativo = true;
            this.cardRelatorio.info = response.data.info;

            this.cardRelatorio.itens = [];

            response.data.produtos.forEach((item, index) => {
              this.cardRelatorio.itens.push({
                ...item,
                id: index,
                idfornecedor: item.id,
                razao_social: `${item.id} - ${item.razao_social}`,
                descricao_produto: `${item.idproduto} - ${item.descricao_produto}`
              });
            });

            if (this.cardRelatorio.filtros.segmento !== "Todos") {
              this.cardRelatorio.info += ` / Segmento: ${this.cardRelatorio.filtros.segmento}`
            }
          })
          .catch(() => this.Helpers.logout())
      );
    },

    buscarProdutosTotal() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        fornecedor: this.cardRelatorio.fornecedor,
        comprador: this.cardRelatorio.comprador,
        familia_produto: this.cardRelatorio.familia_produto,
        grupo_de_analise: this.cardRelatorio.grupo_de_analise,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getProdutosTodal(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.cardRelatorio.ativo = true;
            this.cardRelatorio.info = response.data.info;
            this.cardRelatorio.itens = response.data.produtos;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarProdutosExcesso() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        fornecedor: this.cardRelatorio.fornecedor,
        comprador: this.cardRelatorio.comprador,
        familia_produto: this.cardRelatorio.familia_produto,
        grupo_de_analise: this.cardRelatorio.grupo_de_analise,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getProdutosExcesso(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.cardRelatorio.ativo = true;
            this.cardRelatorio.info = response.data.info;
            this.cardRelatorio.itens = response.data.produtos;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarProdutosOk() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        fornecedor: this.cardRelatorio.fornecedor,
        comprador: this.cardRelatorio.comprador,
        familia_produto: this.cardRelatorio.familia_produto,
        grupo_de_analise: this.cardRelatorio.grupo_de_analise,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getProdutosOk(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.cardRelatorio.ativo = true;
            this.cardRelatorio.info = response.data.info;
            this.cardRelatorio.itens = response.data.produtos;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarProdutosAComprar() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        fornecedor: this.cardRelatorio.fornecedor,
        comprador: this.cardRelatorio.comprador,
        familia_produto: this.cardRelatorio.familia_produto,
        relatorioEscolhido: 4, //trocar coluna idfamilia_produto por iddepartamento no back-end
        grupo_de_analise: this.cardRelatorio.grupo_de_analise,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getProdutosAComprar(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.cardRelatorio.ativo = true;
            this.cardRelatorio.info = response.data.info;
            this.cardRelatorio.itens = response.data.produtos;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarProdutosEmTransito() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        fornecedor: this.cardRelatorio.fornecedor,
        comprador: this.cardRelatorio.comprador,
        familia_produto: this.cardRelatorio.familia_produto,
        grupo_de_analise: this.cardRelatorio.grupo_de_analise,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getProdutosEmTransito(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.cardRelatorio.ativo = true;
            this.cardRelatorio.info = response.data.info;
            this.cardRelatorio.itens = response.data.produtos;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
  },
};
</script>

<style scoped>
.texto-valor {
  margin: 0;
}
.texto-valor span {
  font-weight: bolder;
}
.table-simples tr th {
  color: #666;
}
</style>

<style>
#tr-progress {
  border: 0;
  vertical-align: top;
  height: 3px;
}
#tr-progress:hover {
  background: #fff;
}
.text-color-red {
  color: #ff0000;
}
</style>
